import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createTextVNode as _createTextVNode, openBlock as _openBlock, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-f2bfd80a"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "feedback-dialog" }
const _hoisted_2 = { class: "info-card" }
const _hoisted_3 = { class: "info-item" }
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "info-label" }, "公司", -1))
const _hoisted_5 = { class: "info-value" }
const _hoisted_6 = { class: "info-item" }
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "info-label" }, "渠道", -1))
const _hoisted_8 = { class: "info-value" }
const _hoisted_9 = { class: "info-item" }
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "info-label" }, "客户编码", -1))
const _hoisted_11 = { class: "info-value" }
const _hoisted_12 = { class: "info-item info-item-name" }
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "info-label" }, "客户名称", -1))
const _hoisted_14 = ["title"]
const _hoisted_15 = { class: "info-item" }
const _hoisted_16 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "info-label" }, "业务员", -1))
const _hoisted_17 = { class: "info-value" }
const _hoisted_18 = ["value"]
const _hoisted_19 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "section-title" }, "应收合计", -1))
const _hoisted_20 = { class: "upload-box" }
const _hoisted_21 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "upload-hint" }, " 最多可上传5个文件（支持JPG、PNG、PDF格式） ", -1))

import { computed, reactive, ref, watch } from 'vue';
import { message, Upload } from 'ant-design-vue';
import type { FormInstance, Rule } from 'ant-design-vue/es/form';
import type { TableColumnsType, UploadProps } from 'ant-design-vue';
import zhCN from 'ant-design-vue/es/locale/zh_CN';
import dayjs from 'dayjs';
import 'dayjs/locale/zh-cn';
import type { ReceivableCustomerItem } from './index';
import { saveReceivableFeedback } from './index';
import { uploadFileToObs } from './obsUpload';

export interface DqysEntry {
  key: string;
  value: number;
}


export default /*#__PURE__*/_defineComponent({
  __name: 'FeedbackDialog',
  props: {
    visible: { type: Boolean },
    record: null,
    dqysEntries: null
  },
  emits: ["update:visible", "submitted"],
  setup(__props: any, { emit }: { emit: ({
  (e: 'update:visible', value: boolean): void;
  (e: 'submitted'): void;
}), expose: any, slots: any, attrs: any }) {

const props = __props as {
  visible: boolean;
  record: ReceivableCustomerItem | null;
  /** 已按原 JSON 顺序解析好的明细 */
  dqysEntries: DqysEntry[];
}

dayjs.locale('zh-cn');





const submitting = ref(false);
const formRef = ref<FormInstance>();
const fileList = ref<UploadProps['fileList']>([]);

const form = reactive({
  expectAmount: '',
  expectDate: undefined as string | undefined,
  reason: '',
});

/** 对齐设计器：字段下方红字「必填」 */
const formRules: Record<string, Rule[]> = {
  expectAmount: [{ required: true, whitespace: true, message: '必填', trigger: 'blur' }],
  expectDate: [{ required: true, message: '必填', trigger: 'change' }],
  reason: [{ required: true, whitespace: true, message: '必填', trigger: 'blur' }],
};

const FIELD_LABELS: Record<string, string> = {
  expectAmount: '预期回款金额',
  expectDate: '预计回款日期',
  reason: '原因及说明',
};

const channelCode = computed(() => props.record?.dissaleChannelCode || '');

/** 金额统一保留两位小数（四舍五入） */
function round2(value: number): number {
  return Math.round((Number(value) || 0) * 100) / 100;
}

/** 应收合计：后端已冲抵后的各列求和 */
const totalAmount = computed(() =>
  round2(props.dqysEntries.reduce((sum, item) => sum + (Number(item.value) || 0), 0)),
);

/** 展示用各列：直接使用后端冲抵后的值，前端不再二次冲抵 */
const displayDqysValues = computed(() =>
  props.dqysEntries.map((item) => round2(Number(item.value) || 0)),
);

function formatMoney(value: number) {
  return round2(value).toFixed(2);
}

/**
 * 列宽按固定表头长度设定（弹窗 990、兼顾 13 寸屏，不拉宽弹窗）：
 * - 应收合计：表头短但金额可到十余位，以金额为准
 * - 后五列：值不长于表头，按最长表头「yyyyMMdd以后到期应收款」定宽
 */
const DQYS_TOTAL_COL_WIDTH = 126;
const DQYS_DETAIL_COL_WIDTH = 160;

const dqysColumns = computed<TableColumnsType>(() => {
  const cols: TableColumnsType = [
    {
      title: '应收合计',
      dataIndex: 'total',
      key: 'total',
      align: 'center',
      width: DQYS_TOTAL_COL_WIDTH,
    },
  ];
  props.dqysEntries.forEach((item, index) => {
    cols.push({
      title: item.key,
      dataIndex: `col_${index}`,
      key: `col_${index}`,
      align: 'center',
      width: DQYS_DETAIL_COL_WIDTH,
    });
  });
  return cols;
});

const dqysDataSource = computed(() => {
  const row: Record<string, string> = {
    key: 'dqys-row',
    total: formatMoney(totalAmount.value),
  };
  displayDqysValues.value.forEach((value, index) => {
    row[`col_${index}`] = formatMoney(value);
  });
  return [row];
});

watch(
  () => props.visible,
  (open) => {
    if (open) {
      form.expectAmount = '';
      form.expectDate = undefined;
      form.reason = '';
      fileList.value = [];
      formRef.value?.clearValidate();
    }
  },
);

const ALLOW_EXT = ['.jpg', '.jpeg', '.png', '.pdf'];

const beforeUpload: UploadProps['beforeUpload'] = (file) => {
  const name = (file.name || '').toLowerCase();
  const okExt = ALLOW_EXT.some((ext) => name.endsWith(ext));
  if (!okExt) {
    message.error('仅支持 JPG、PNG、PDF 格式');
    return Upload.LIST_IGNORE;
  }
  if ((fileList.value?.length || 0) >= 5) {
    message.warning('最多只能上传5个文件，请先删除部分文件后再上传');
    return Upload.LIST_IGNORE;
  }
  // false：不自动上传，但仍加入 fileList；提交时再传 OBS
  return false;
};

const handleRemove: UploadProps['onRemove'] = () => true;

const handlePreview: UploadProps['onPreview'] = async (file) => {
  const raw = file.originFileObj;
  if (!raw) {
    if (file.url) window.open(file.url, '_blank');
    return;
  }
  const url = URL.createObjectURL(raw);
  window.open(url, '_blank');
};

function handleCancel() {
  emit('update:visible', false);
}

async function handleSubmit() {
  try {
    await formRef.value?.validate();
  } catch (err: unknown) {
    // 对齐设计器：顶部「字段名 必填」+ 字段下方红字「必填」
    const errorFields = (err as { errorFields?: Array<{ name: Array<string | number> }> })
      ?.errorFields;
    const firstName = errorFields?.[0]?.name?.[0];
    const label = firstName != null ? FIELD_LABELS[String(firstName)] : '';
    message.error(label ? `${label} 必填` : '请完善必填信息');
    return Promise.reject();
  }

  const sapCustomerCode = (props.record?.customerCode || '').trim();
  const dissaleChannelCode = (channelCode.value || '').trim();
  if (!sapCustomerCode) {
    message.error('缺少客户编码，无法提交');
    return Promise.reject();
  }
  if (!dissaleChannelCode) {
    message.error('缺少渠道信息，无法提交');
    return Promise.reject();
  }

  submitting.value = true;
  try {
    const files = (fileList.value || [])
      .map((item) => item.originFileObj)
      .filter((f): f is File => !!f);

    const uploadedUrls: string[] = [];
    for (const file of files) {
      const url = await uploadFileToObs(file);
      uploadedUrls.push(url);
    }

    await saveReceivableFeedback({
      dissaleChannelCode,
      sapCustomerCode,
      corpCode: (props.record?.corpCode || '').trim(),
      feedbackMessage: form.reason.trim(),
      expectRepayAmount: form.expectAmount.trim(),
      expectRepayDate: form.expectDate,
      customerFileUrl: uploadedUrls,
    });

    message.success('提交反馈成功');
    emit('update:visible', false);
    emit('submitted');
  } catch (error) {
    message.error(error instanceof Error ? error.message : '提交失败');
    return Promise.reject();
  } finally {
    submitting.value = false;
  }
}

return (_ctx: any,_cache: any) => {
  const _component_a_table = _resolveComponent("a-table")!
  const _component_a_input = _resolveComponent("a-input")!
  const _component_a_form_item = _resolveComponent("a-form-item")!
  const _component_a_col = _resolveComponent("a-col")!
  const _component_a_date_picker = _resolveComponent("a-date-picker")!
  const _component_a_textarea = _resolveComponent("a-textarea")!
  const _component_a_button = _resolveComponent("a-button")!
  const _component_a_upload = _resolveComponent("a-upload")!
  const _component_a_row = _resolveComponent("a-row")!
  const _component_a_form = _resolveComponent("a-form")!
  const _component_a_modal = _resolveComponent("a-modal")!
  const _component_a_config_provider = _resolveComponent("a-config-provider")!

  return (_openBlock(), _createBlock(_component_a_config_provider, { locale: _unref(zhCN) }, {
    default: _withCtx(() => [
      _createVNode(_component_a_modal, {
        visible: __props.visible,
        title: "反馈",
        width: 990,
        "confirm-loading": submitting.value,
        "mask-closable": false,
        "destroy-on-close": "",
        "wrap-class-name": "feedback-dialog-modal",
        "ok-text": "保存",
        "cancel-text": "取消",
        onOk: handleSubmit,
        onCancel: handleCancel
      }, {
        default: _withCtx(() => [
          _createElementVNode("div", _hoisted_1, [
            _createElementVNode("div", _hoisted_2, [
              _createElementVNode("div", _hoisted_3, [
                _hoisted_4,
                _createElementVNode("div", _hoisted_5, _toDisplayString(__props.record?.corpCode || '-'), 1)
              ]),
              _createElementVNode("div", _hoisted_6, [
                _hoisted_7,
                _createElementVNode("div", _hoisted_8, _toDisplayString(__props.record?.channel || '-'), 1)
              ]),
              _createElementVNode("div", _hoisted_9, [
                _hoisted_10,
                _createElementVNode("div", _hoisted_11, _toDisplayString(__props.record?.customerCode || '-'), 1)
              ]),
              _createElementVNode("div", _hoisted_12, [
                _hoisted_13,
                _createElementVNode("div", {
                  class: "info-value",
                  title: __props.record?.customerName || '-'
                }, _toDisplayString(__props.record?.customerName || '-'), 9, _hoisted_14)
              ]),
              _createElementVNode("div", _hoisted_15, [
                _hoisted_16,
                _createElementVNode("div", _hoisted_17, _toDisplayString(__props.record?.salesman || '-'), 1)
              ])
            ]),
            _createElementVNode("input", {
              type: "hidden",
              value: _unref(channelCode)
            }, null, 8, _hoisted_18),
            _hoisted_19,
            _createVNode(_component_a_table, {
              class: "dqys-table",
              size: "small",
              bordered: "",
              pagination: false,
              columns: _unref(dqysColumns),
              "data-source": _unref(dqysDataSource),
              "table-layout": "fixed"
            }, null, 8, ["columns", "data-source"]),
            _createVNode(_component_a_form, {
              ref_key: "formRef",
              ref: formRef,
              layout: "vertical",
              class: "feedback-form",
              model: form,
              rules: formRules
            }, {
              default: _withCtx(() => [
                _createVNode(_component_a_row, { gutter: 16 }, {
                  default: _withCtx(() => [
                    _createVNode(_component_a_col, { span: 12 }, {
                      default: _withCtx(() => [
                        _createVNode(_component_a_form_item, {
                          label: "预期回款金额",
                          name: "expectAmount"
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_a_input, {
                              value: form.expectAmount,
                              "onUpdate:value": _cache[0] || (_cache[0] = ($event: any) => ((form.expectAmount) = $event)),
                              "allow-clear": "",
                              placeholder: "请输入预期回款金额"
                            }, null, 8, ["value"])
                          ]),
                          _: 1
                        })
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_a_col, { span: 12 }, {
                      default: _withCtx(() => [
                        _createVNode(_component_a_form_item, {
                          label: "预计回款日期",
                          name: "expectDate"
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_a_date_picker, {
                              value: form.expectDate,
                              "onUpdate:value": _cache[1] || (_cache[1] = ($event: any) => ((form.expectDate) = $event)),
                              "value-format": "YYYY-MM-DD",
                              style: {"width":"100%"},
                              placeholder: "请选择预计回款日期"
                            }, null, 8, ["value"])
                          ]),
                          _: 1
                        })
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_a_col, { span: 24 }, {
                      default: _withCtx(() => [
                        _createVNode(_component_a_form_item, {
                          label: "原因及说明",
                          name: "reason",
                          class: "reason-form-item"
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_a_textarea, {
                              value: form.reason,
                              "onUpdate:value": _cache[2] || (_cache[2] = ($event: any) => ((form.reason) = $event)),
                              class: "reason-textarea",
                              rows: 4,
                              placeholder: "请输入原因及说明"
                            }, null, 8, ["value"])
                          ]),
                          _: 1
                        })
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_a_col, { span: 24 }, {
                      default: _withCtx(() => [
                        _createVNode(_component_a_form_item, { label: "附件" }, {
                          default: _withCtx(() => [
                            _createElementVNode("div", _hoisted_20, [
                              _createVNode(_component_a_upload, {
                                "file-list": fileList.value,
                                "onUpdate:file-list": _cache[3] || (_cache[3] = ($event: any) => ((fileList).value = $event)),
                                "before-upload": beforeUpload,
                                "max-count": 5,
                                accept: ".jpg,.jpeg,.png,.pdf",
                                onPreview: handlePreview,
                                onRemove: handleRemove
                              }, {
                                default: _withCtx(() => [
                                  _createVNode(_component_a_button, null, {
                                    default: _withCtx(() => [
                                      _createTextVNode("上传附件")
                                    ]),
                                    _: 1
                                  })
                                ]),
                                _: 1
                              }, 8, ["file-list"]),
                              _hoisted_21
                            ])
                          ]),
                          _: 1
                        })
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }, 8, ["model"])
          ])
        ]),
        _: 1
      }, 8, ["visible", "confirm-loading"])
    ]),
    _: 1
  }, 8, ["locale"]))
}
}

})